import { AxiosResponse } from "axios";
import { axiosInstance } from "../../../../../axiosInstance";

/**
 * forgot password admin user
 *
 * @param id
 * @returns
 */
export const forgotPasswordAdminUser = async (
  id: string
): Promise<AxiosResponse> => {
  return axiosInstance.post(`/backoffice_users/${id}/forgot_password`);
};

/**
 * forgot password user
 *
 * @param id
 * @returns
 */
export const forgotPasswordUser = async (
  id: string
): Promise<AxiosResponse> => {
  return axiosInstance.post(`/users/${id}/forgot_password`);
};
